<template>
	<div class="my-account cash-withdrawal">
		<div class="wrapper">
			<div class="header">
				<div class="headerCon">
					<div class="account acea-row row-top row-between">
						<div class="assets">
							<div>我的金券</div>
							<div class="money">{{ new_jinquan }}</div>
						</div>
					</div>
					<div class="cumulative acea-row row-top">
						<div class="item">
							<div>1金券=1元</div>
						</div>
						<div class="item">
						</div>
					</div>
				</div>
			</div>
			<div class="list">
				<div class="bt">
					金券转赠
				</div>
				<div class="item acea-row row-between-wrapper">
					<div class="name">会员ID</div>
					<div class="input">
						<input placeholder="请输入被赠人ID" v-model="post.uuid" />
					</div>
				</div>
				<div class="item acea-row row-between-wrapper">
					<div class="name">赠送金额</div>
					<div class="input">
						<input placeholder="请输入赠送金额" v-model="post.money" />
					</div>
				</div>
				<div class="tip">转赠后不可退回</div>
				<div class="bnt bg-color-red" @click="submitted">确认赠送</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		pay
	} from "@libs/wechat";
	import {
		isWeixin
	} from "@utils";
	import {
		rechargeWechat,
		getRechargeApi,
		zhuanUser,
		getBalance
	} from "@api/user";

	export default {
		name: "Recharge",
		props: {},
		data: function() {
			return {
				
				active: 0,
				payType: ["weixin"],
				from: isWeixin() ? "weixin" : "weixinh5",
				money: "",
				new_jinquan: "",
				picList: [],
				activePic: 0,
				numberPic: "",
				rechar_id: 0,
				rechargeAttention: [],
				post:{
					money:'',
					uuid:''
				}
			};
		},
		computed: mapGetters(["userInfo"]),
		mounted: function() {
			// this.new_jinquan = this.userInfo.new_jinquan;
			this.getIndex();
		},
		methods: {
			getIndex: function() {
				let that = this;
				getBalance().then(
					res => {
						that.new_jinquan = res.data.new_jinquan;
					},
					err => {
						that.$dialog.message(err.msg);
					}
				);
			},
			submitted(){
				console.log("11")
				console.log(this.post)
				var that = this
				var money = Number(that.post.money)
				if (!that.post.uuid) {
					return that.$dialog.toast({
						mes: "请输入被赠人ID"
					});
				}
				if (!money) {
					return that.$dialog.toast({
						mes: "请输入您要转赠的金额"
					});
				} else if (money < 0.01) {
					return that.$dialog.toast({
						mes: "转入金额不能低于0.01"
					});
				} else if (money > this.new_jinquan) {
						return that.$dialog.toast({
							mes: "转增金券不能大于当前金券"
						});
					}
				this.$dialog.confirm({
					mes: "转增金券后不可退回",
					title: "转增金券",
					opts: [{
							txt: "确认",
							color: false,
							callback: () => {
								console.log("222")
								zhuanUser({uuid: that.post.uuid,money: money}).then(res => {
									// this.new_jinquan = Number(this.new_jinquan) - money
									that.post.uuid = ''
									that.post.money = ''
									this.getIndex()
									console.log(res)
									return that.$dialog.toast({
										mes: res.msg
									});
									
								})
								.catch(res => {
									that.$dialog.toast({
										mes: res.msg
									});
								});
							}
						},
						{
							txt: "取消",
							color: false,
							callback: () => {
								return that.$dialog.toast({
									mes: "已取消"
								});
							}
						}
					]
				});
			},
			/**
			 * 充值额度选择
			 */
			// getRecharge() {
			// 	getRechargeApi()
			// 		.then(res => {
			// 			this.picList = res.data.recharge_quota;
			// 			if (this.picList[0]) {
			// 				this.rechar_id = this.picList[0].id;
			// 				this.numberPic = this.picList[0].price;
			// 			}
			// 			this.rechargeAttention = res.data.recharge_attention || [];
			// 		})
			// 		.catch(res => {
			// 			this.$dialog.toast({
			// 				mes: res
			// 			});
			// 		});
			// },
			/**
			 * 选择金额
			 */
			// picCharge(idx, item) {
			// 	this.activePic = idx;
			// 	if (item === undefined) {
			// 		this.rechar_id = 0;
			// 		this.numberPic = "";
			// 	} else {
			// 		this.money = "";
			// 		this.rechar_id = item.id;
			// 		this.numberPic = item.price;
			// 	}
			// },
			// navRecharges: function(index) {
			// 	this.active = index;
			// 	this.rechar_id = this.picList[0].id;
			// 	this.numberPic = this.picList[0].price;
			// 	this.activePic = 0;
			// 	this.money = "";
			// },
			// recharge: function() {
			// 	let that = this,
			// 		price = Number(this.money);
			// 	if (that.active) {
			// 		if (price === 0) {
			// 			return that.$dialog.toast({
			// 				mes: "请输入您要转入的金额"
			// 			});
			// 		} else if (price < 0.01) {
			// 			return that.$dialog.toast({
			// 				mes: "转入金额不能低于0.01"
			// 			});
			// 		} else if (price > this.userInfo.commissionCount) {
			// 			return that.$dialog.toast({
			// 				mes: "转入金额不能大于可提现佣金"
			// 			});
			// 		}
			// 		this.$dialog.confirm({
			// 			mes: "转入余额无法在转出，请确认转入",
			// 			title: "转入余额",
			// 			opts: [{
			// 					txt: "确认",
			// 					color: false,
			// 					callback: () => {
			// 						rechargeWechat({
			// 								price: price,
			// 								from: that.from,
			// 								type: 1
			// 							})
			// 							.then(res => {
			// 								that.new_jinquan = add(price, parseInt(that.new_jinquan));
			// 								that.userInfo.commissionCount = sub(
			// 									that.userInfo.commissionCount,
			// 									price
			// 								);
			// 								that.money = "";
			// 								return that.$dialog.toast({
			// 									mes: res.msg
			// 								});
			// 							})
			// 							.catch(res => {
			// 								that.$dialog.toast({
			// 									mes: res.msg
			// 								});
			// 							});
			// 					}
			// 				},
			// 				{
			// 					txt: "取消",
			// 					color: false,
			// 					callback: () => {
			// 						return that.$dialog.toast({
			// 							mes: "已取消"
			// 						});
			// 					}
			// 				}
			// 			]
			// 		});
			// 	} else {
			// 		if (this.picList.length == this.activePic && price === 0) {
			// 			return that.$dialog.toast({
			// 				mes: "请输入您要充值的金额"
			// 			});
			// 		} else if (this.picList.length == this.activePic && price < 0.01) {
			// 			return that.$dialog.toast({
			// 				mes: "充值金额不能低于0.01"
			// 			});
			// 		}
			// 		rechargeWechat({
			// 				price: that.rechar_id == 0 ? that.money : that.numberPic,
			// 				from: that.from,
			// 				rechar_id: that.rechar_id
			// 			})
			// 			.then(res => {
			// 				let data = res.data;
			// 				if (data.type == "weixinh5") {
			// 					location.replace(data.data.mweb_url);
			// 					this.$dialog.confirm({
			// 						mes: "充值余额",
			// 						opts: [{
			// 								txt: "已充值",
			// 								color: false,
			// 								callback: () => {
			// 									that.$router.replace({
			// 										path: "/user/account"
			// 									});
			// 								}
			// 							},
			// 							{
			// 								txt: "查看余额",
			// 								color: false,
			// 								callback: () => {
			// 									that.$router.replace({
			// 										path: "/user/account"
			// 									});
			// 								}
			// 							}
			// 						]
			// 					});
			// 				} else {
			// 					pay(data.data)
			// 						.finally(() => {
			// 							that.new_jinquan = add(
			// 								price,
			// 								parseInt(that.userInfo.new_jinquan)
			// 							);
			// 							that.$dialog.toast({
			// 								mes: "支付成功"
			// 							});
			// 						})
			// 						.catch(function() {
			// 							that.$dialog.toast({
			// 								mes: "支付失败"
			// 							});
			// 						});
			// 				}
			// 			})
			// 			.catch(res => {
			// 				that.$dialog.toast({
			// 					mes: res.msg
			// 				});
			// 			});
			// 	}
			// }
		}
	};
</script>
<style scoped>
	.rechargeBox {
		height: 100%;
		background: #fff;
	}

	#iframe {
		display: none;
	}

	.pic-box-color-active {
		background-color: #ec3323 !important;
		color: #fff !important;
	}

	.pic-box-active {
		width: 2.16rem;
		height: 1.2rem;
		background-color: #ec3323;
		border-radius: 0.2rem;
	}

	.picList {
		margin-bottom: 0.3rem;
		margin-top: 0.3rem;
	}
	.my-account .wrapper .list .item{
		width: 4.3rem;
		margin: 0 auto;
	}
	.my-account .wrapper .list .item .name{
		width: 1.3rem;
	}
	.my-account .wrapper .list .bt{
		line-height: 2rem;
		text-align: center;
		font-size: 0.4rem;
	}
	.my-account .wrapper .list .item .input{
		width: 3rem;
	}
	.font-color {
		color: #e83323;
	}

	/* .recharge {
		border-radius: 0.1rem;
		width: 100%;
		background-color: #fff;
		margin: 0.2rem auto 0 auto;
		padding: 0.3rem;
		border-top-right-radius: 0.39rem;
		border-top-left-radius: 0.39rem;
		margin-top: -0.45rem;
		box-sizing: border-box;
	}

	.recharge .nav {
		height: 0.75rem;
		line-height: 0.75rem;
		padding: 0 1rem;
	}

	.recharge .nav .item {
		font-size: 0.3rem;
		color: #333;
	}

	.recharge .nav .item.on {
		font-weight: bold;
		border-bottom: 0.04rem solid #e83323;
	}

	.recharge .info-wrapper {}

	.recharge .info-wrapper .money {
		margin-top: 0.6rem;
		padding-bottom: 0.2rem;
		border-bottom: 1px dashed #ddd;
		text-align: center;
	}

	.recharge .info-wrapper .money span {
		font-size: 0.56rem;
		color: #333;
		font-weight: bold;
	}

	.recharge .info-wrapper .money input {
		display: inline-block;
		width: 3rem;
		font-size: 0.84rem;
		text-align: center;
		color: #282828;
		font-weight: bold;
		padding-right: 0.7rem;
	}

	.recharge .info-wrapper .money input::placeholder {
		color: #ddd;
	}

	.recharge .info-wrapper .money input::-webkit-input-placeholder {
		color: #ddd;
	}

	.recharge .info-wrapper .money input:-moz-placeholder {
		color: #ddd;
	}

	.recharge .info-wrapper .money input::-moz-placeholder {
		color: #ddd;
	}

	.recharge .info-wrapper .money input:-ms-input-placeholder {
		color: #ddd;
	} */

	.tip {
		font-size: 0.28rem;
		color: #333333;
		font-weight: 800;
		margin-bottom: 0.14rem;
	}

	.tip-samll {
		font-size: 0.24rem;
		color: #333333;
		margin-bottom: 0.14rem;
	}

	.tip-box {
		margin-top: 0.3rem;
	}
	.tip {
	    font-size: 0.26rem;
	    color: #999;
	    margin-top: 0.25rem;
	}

	/* .recharge .info-wrapper .tips span {
		color: #ef4a49;
	}

	.recharge .info-wrapper .pay-btn {
		display: block;
		width: 100%;
		height: 0.86rem;
		margin: 0.5rem auto 0 auto;
		line-height: 0.86rem;
		text-align: center;
		color: #fff;
		border-radius: 0.5rem;
		font-size: 0.3rem;
		font-weight: bold;
	}

	.payment-top {
		width: 100%;
		height: 3.5rem;
		background-color: #e83323;
	}

	.payment-top .name {
		font-size: 0.26rem;
		color: rgba(255, 255, 255, 0.8);
		margin-top: -0.38rem;
		margin-bottom: 0.3rem;
	}

	.payment-top .pic {
		font-size: 0.32rem;
		color: #fff;
	}

	.payment-top .pic-font {
		font-size: 0.78rem;
		color: #fff;
	}

	.picList .pic-box {
		width: 32%;
		height: auto;
		border-radius: 0.2rem;
		margin-top: 0.21rem;
		padding: 0.2rem 0;
	}

	.pic-box-color {
		background-color: #f4f4f4;
		color: #656565;
	}

	.pic-number {
		font-size: 0.22rem;
	}

	.pic-number-pic {
		font-size: 0.38rem;
		margin-right: 0.1rem;
		text-align: center;
	}

	.pic-box-money {
		width: 100%;
		display: block;
	} */
</style>
